import { cn } from "@/lib/utils";

interface AuthCardProps {
    children: React.ReactNode;
    /** Primary auth flows use `default`; paid signup uses `wide`; choice grids use `extraWide`. */
    variant?: "default" | "wide" | "extraWide";
    className?: string;
}

export function AuthCard({ children, variant = "default", className }: AuthCardProps) {
    return (
        <div
            className={cn(
                "md:bg-white/50 md:shadow-sm md:border md:border-border/80 md:dark:border-border md:rounded-xl w-full text-card-foreground",
                variant === "wide" ? "max-w-3xl" : variant === "extraWide" ? "max-w-5xl" : undefined,
                className
            )}
        >
            <div className="flex flex-col gap-6 md:p-8 lg:p-10 px-2 md:px-8 py-4 md:py-8">{children}</div>
        </div>
    );
}
